module.exports = __webpack_public_path__ + "static/media/023-luxembourg.4fb25f04.svg";